import angular from 'angular';

import '../../services/datastorage';

angular.module('folkeuni').component('cookieWarning', {
  bindings: {
    cookiePageUrl: '@'
  },
  controller: function(DataStorage) {
    var $ctrl = this;
    $ctrl.cookiesAccepted = true;

    $ctrl.cookiesAccept = function() {
      $ctrl.cookiesAccepted = true;

      DataStorage.set('cookiesAccepted', 'true');
    }

    $ctrl.$onInit = function() {

      DataStorage.get("cookiesAccepted").then(function(data){
        $ctrl.cookiesAccepted = data;
      },function(message){
      });

      if ($ctrl.cookiesAccepted != 'true') {
        $ctrl.cookiesAccepted = false;
      }
    }
  },
  templateUrl: '/shop-dist/templates/cookie-warning.html',
  transclude: true
});
